import { FormGroup } from '@angular/forms';
import { SelectedImage } from '@shared/components/drag-n-drop/drag-n-drop.component';
import { QuestionnaireDTO } from '@shared/components/questionnaire/models';
import { PolicyType, QuoteType } from 'models/DTOs';

export enum HomeQuotePages {
  //BUILDING_COVER,
  TYPE_OF_COVERAGE,
  BUILDING_COVER,
  HOME_ADDRESS,
  PROPERTY_TYPE,
  BUILDING_MATERIALS,
  CONTENT_COVER,
  HOME_IMPROVEMENTS_COVER,
  CONFIRM_OWNER_DETAILS,
  PERSONALIZED_QUOTES,
  COVER_FINALIZATION,
  ADDITIONAL_INSURERS,
  REQUIRED_DOCUMENT,
  CLIENT_HISTORY,
  DECLARATION
}

export enum EmploymentStatusType {
  Employed = 'Employed',
  Unemployed = 'Unemployed',
  Retired = 'Retired'
}

export enum GenderType {
  Male = 'Male',
  Female = 'Female'
}

export enum FamilyMemberType {
  Spouse = 1,
  Child = 2
}

export enum Experience {
  More = 1,
  Less = 2
}

export enum InsuredPersonType {
  Driver = 1,
  AdditionalInsured = 2
}

export enum SubmitAction {
  Save,
  Payment
}

// MOTOR QUOTE

export interface DriverInfo {
  fullName: string;
  age: number;
  gender: GenderType;
  experience: Experience;
  //
  genderType: string;
  dateOfBirth: string;
  moreThanYears: string;
  typeOfLicense: string;
  licenseGroup: string;
  countryOfIssue: string;
  firstIssuedDate: string;
  issuedDate: string;
  expiryDate: string;
  relationshipToInsured: string;
  isOwner: boolean;
}

export interface VehicleInfo {
  make: string;
  model: string;
  year: string;
}

export interface MotorQuoteDTO {
  typeOfCoverage: string;
  //driversInfo: DriverInfo[];
  questionnaire: QuestionnaireDTO;
  vehicles: VehicleDetails[];
  trailers: Trailer[];
  drivers: Driver[];
  civilServants: string;
  memberId: string;
  safeDriverProgram: string;
  certificateNo: string;
  multiPolicy: string;
  policyNumber: string;
  seniorCitizen: string;
  cinicoStaff: string;
  areThereExistingDamages: string;
  startDate: Date | undefined;
  fullName: string;
  genderType: string;
  dateOfBirth: Date | undefined;
  moreThanYears: string;
  licenseNo: string;
  typeOfLicense: string;
  otherLicenseGroup: string;
  licenseGroup: string;
  countryOfIssue: string;
  firstIssuedDate: Date | undefined;
  issuedDate: Date | undefined;
  expiryDate: Date | undefined;
  describeDamages: string;
  driversLicenceImages: SelectedImage[];
}

export interface Driver {
  genderType: string;
  fullName: string;
  dateOfBirth: Date | undefined;
  moreThanYears: string;
  licenseNo: string;
  typeOfLicense: string;
  licenseGroup: string;
  otherLicenseGroup: string;
  countryOfIssue: string;
  firstIssuedDate: Date | undefined;
  issuedDate: Date | undefined;
  expiryDate: Date | undefined;
  relationshipToInsured: string;
  driversLicenceImages: SelectedImage[];
}

export interface VehicleDetails {
  vehicleMake: string;
  vehicleModel: string;
  vehicleYear: string;
  vehicleBodyType: string;
  vehicleEngineSize: string;
  vehicleIslandLocation: string;
  vehicleCurrentValue: string;
  vehicleEngineType: string;
  vehicleOrigin: string;
  isTheVehicleMortgaged: string;
  vehicleMortgageName: string;
  additionalNoClaimDiscountProtection: string;
  discountPeriod: string;
  modificationsAccessories: string;
  engineChangedType: string;
  engineChangedCapacity: string;
  engineChangedTunedValue: string;
  antiTheftDeviceValue: string;
  antiTheftDeviceType: string;
  wheelsAndRimsValue: string;
  wheelsAndRimsType: string;
  otherValue: string;
  otherType: string;
  yourPolicyIncludesWindscreenCover: string;
  additionalValue: string;
  excessWaiverBenefit: string;
  checkboxEngineChangedTuned: string;
  checkboxAntiTheftDevice: string;
  checkboxWheelsAndRims: string;
  checkboxOther: string;
  vehicleVINChassisNo: string;
  vehicleRegistrationNo: string;
  addVehicleModel: string;
  vehicleEngineNumber: string;
  vehicleColour: string;
  vehicleMileage: string;
  vehicleMileageType: string;
  vehicleTotalPassengers: string;
  overnightParking: string;
  existingDamage: string;
  existingDamageDetails: string;
  anyOtherInsurancePolicy: string;
  vehicleOtherInsuranceCompany: string;
  vehicleUsedForOther: string;
  vehicleWillTheVehicleExplain: string;
}
export interface Trailer {
  trailerLength: string;
  trailerModel: string;
  trailerMake: string;
  trailerUsedWith: string;
  vehicleYear: string;
}

// HOME QUOTE

export interface SubmitedQuote {
  value: FormGroup | any;
  newState: HomeQuotePages;
}

export interface PageData {
  page: HomeQuotePages;
  data: any;
}

export interface HomeQuoteDTO {
  pageData: PageData[];
}

// HEALTH QUOTE

export enum DependantType {
  Spouse = 0,
  Child = 1
}

export interface HealthQuoteDependantManipulationDTO {
  dependantType: DependantType;
  dependantName: string;
  genderType: GenderType;
  dateOfBirth: Date | undefined;
  height: number;
  weight: number;
  employerName: string | undefined;
  employerPhone: string | undefined;
  questionnaires: HealthQuoteQuestionnaireDTO[] | undefined;
}

export type HealthQuoteDependantInsertDTO = HealthQuoteDependantManipulationDTO;

export interface HealthQuoteQuestionnaireDTO {
  questionnaireID: string;
  questionGroupHeader: string;
  questionGroupText: string;
  questions: HealthQuoteQuestionnaireDetailsDTO[];
}

export interface HealthQuoteQuestionnaireDetailsDTO {
  healthQuoteQuestionID: string;
  healthQuoteQuestionGroupID: string;
  questionSequence: number;
  questionHeader: string;
  questionText: string | undefined;
  isAnsweredYes: boolean;
  approvedInsurerName: string | undefined;
  approvedInsurerTelephone: string | undefined;
  patientName: string | undefined;
  diagnosisDate: string | undefined;
  treatment: string | undefined;
  medicalProviderNameAddress: string | undefined;
}

export enum HealthQuoteType {
  SHIC = 1,
  SHIC_PLUS = 2
}

export interface HealthQuoteDTO {
  id: string;
  healthQuoteType: HealthQuoteType;
  questionnaires: HealthQuoteQuestionnaireDTO[] | undefined;
}

export interface HealthQuoteManipulationDTO {
  healthQuoteType: QuoteType;
  applicantFirstName: string;
  applicantLastName: string;
  applicantMiddleName: string | undefined;
  applicantDateOfBirth: Date | undefined;
  applicantGenderType: GenderType;
  applicantHeight: number | undefined;
  applicantWeight: number | undefined;
  applicantEmail: string | undefined;
  applicantPhone: string | undefined;
  applicantAddress: string | undefined;
  applicantDistrict: string | undefined;
  applicantPOBox: string | undefined;
  applicantPostalCode: string | undefined;
  employmentStatusType: EmploymentStatusType;
  employerName: string | undefined;
  employerCode: string | undefined;
  employerEmail: string | undefined;
  employerPhone: string | undefined;
  employerAddress: string | undefined;
  employerPOBox: string | undefined;
  postalCode: string | undefined;
  healthQuoteDependants: HealthQuoteDependantInsertDTO[] | undefined;
  questionnaires: HealthQuoteQuestionnaireDTO[] | undefined;
}

export type HealthQuoteInsertDTO = HealthQuoteManipulationDTO;

export interface DraftQuote {
  type: PolicyType;
  quote: MotorQuoteDTO | HomeQuoteDTO | HealthQuoteInsertDTO;
  isDeleted?: boolean | undefined;
  isSigned?: boolean | undefined;
  isSubmited?: boolean | undefined;
  signatureUrl?: string | undefined;
  startDate?: string | undefined;
}

export interface MaterialsData {
  key: number;
  value: string;
  imageURL: string;
}

export interface TypeOfCoverage {
  type: string;
  title: string;
  details: string;
}

export enum HomeCoverage {
  ESSENTIAL = 'HCX',
  ESSENTIAL_PLUS = 'HCC'
}
export interface IconData {
  title: string;
  icon: string;
}

export interface PaymentPriceAndPlanValue {
  price: number;
  plan: number;
}
